<svg xmlns="http://www.w3.org/2000/svg" width="92" height="87" viewBox="0 0 92 87">
    <defs>
        <linearGradient id="tblp3gf2za" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
        <linearGradient id="6hnm060x5b" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#tblp3gf2za)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125H90.875V85.875H1.125z"/>
        <path stroke="#313131" stroke-width=".5" d="M22 69c3.518 0 6.43-2.595 6.926-5.976.032-.222.057-.564.074-1.024h7v-7H22c-3.866 0-7 3.134-7 7s3.134 7 7 7z"/>
        <path fill="url(#6hnm060x5b)" d="M31 21H61V71H31z"/>
        <path stroke="#0069C4" stroke-linecap="square" stroke-width="2.5" d="M58 61.443L71 61.557"/>
        <path stroke="#D90338" stroke-linecap="square" stroke-width="2.5" d="M58 29.393L71 29.607"/>
        <path fill="#FFF" d="M51.927 50.58S58.163 37.644 44.834 30c0 0 1.874 3.332-2.515 7.336-3.667 3.332-12.392 14.336.428 20.664 0 0-5.193-7.112 1.258-11.032 0 0-2.463 4.144 1.953 7.644 2.623-2.856 1.927-4.312 1.927-4.312s3.801 3.192.99 7.7c0 0 10.68-2.688 5.889-14 0 0 .348 4.34-2.837 6.58z" opacity=".65"/>
    </g>
</svg>
